import {useEffect, useReducer} from 'react'
import {SwipeableHandlers, useSwipeable} from 'react-swipeable'
import {sliderReducer} from './slider-reducer'
import {swipeHandler, swipingHandler} from './slider-swiping-actions'

const initialSliderState = {
  offset: 0,
  desired: 1,
  active: 1,
  withoutAnimate: false
}

const transitionTime = 400

export const useSlider = (
  length: number
): [
  number,
  (n: number, withoutAnimate?: boolean) => void,
  SwipeableHandlers,
  React.CSSProperties
] => {
  const [state, dispatch] = useReducer(sliderReducer, initialSliderState)

  const handlers = useSwipeable({
    onSwiping: e => swipingHandler(e, dispatch),
    onSwipedLeft: e => swipeHandler(e, dispatch, length, 1),
    onSwipedRight: e => swipeHandler(e, dispatch, length, -1),
    trackMouse: false,
    trackTouch: false
  })

  useEffect(() => {
    const id = setTimeout(() => {
      dispatch({type: 'done'})
    }, transitionTime)
    return () => clearTimeout(id)
  }, [state.desired])

  const smooth = `transform ${transitionTime}ms ease`

  const style = {
    transform: 'translateX(0)',
    width: `calc(${100 * length}%)`,
    left: length > 1 ? `calc(-${state.active * 100}%)` : 0,
    transition: ''
  }

  if (state.desired !== state.active) {
    const dist = Math.abs(state.active - state.desired)
    const pref = Math.sign(state.offset || 0)
    const dir =
      (dist > length / 2 ? 1 : -1) * Math.sign(state.desired - state.active)
    const shift = (100 * (pref || dir)) / length
    if (state.withoutAnimate) {
      style.transition = ''
      style.transform = `translateX(${shift}%)`
    } else {
      style.transition = smooth
      style.transform = `translateX(${shift}%)`
    }
  } else if (!isNaN(state.offset)) {
    if (state.offset !== 0) {
      style.transform = `translateX(${state.offset}px)`
    } else {
      style.transition = smooth
    }
  }

  return [
    state.active,
    (n: number, withoutAnimate?: boolean) =>
      dispatch({
        type: withoutAnimate ? 'jump-without-animate' : 'jump',
        desired: n
      }),
    handlers,
    style
  ]
}
